<div class="block">
	<div
		class="bg-grey-50 h-full w-full
		cursor-not-allowed rounded-md border-2 border-gray-500
		text-base font-medium text-gray-500
		shadow md:text-lg">
		<div class="flex h-full w-full items-center justify-center">
			<slot />
		</div>
	</div>
</div>
